const STEP = 10;

/** Etiquetas de referencia para que el numero no sea abstracto. */
function describe(energy: number): string {
  if (energy <= 10) return "En reserva";
  if (energy <= 30) return "Bajo";
  if (energy <= 50) return "Justo";
  if (energy <= 70) return "Bien";
  if (energy <= 90) return "Alto";
  return "A tope";
}

type Props = {
  value: number;
  onChange: (value: number) => void;
};

export function EnergySlider({ value, onChange }: Props) {
  return (
    <div className="energy">
      <div className="energy__head">
        <label className="field__label" htmlFor="energy">
          Nivel de energía
        </label>
        <div className="energy__readout">
          <span className="energy__value">{value}</span>
          <span className="energy__desc">{describe(value)}</span>
        </div>
      </div>

      <input
        id="energy"
        className="energy__slider"
        type="range"
        min={0}
        max={100}
        step={STEP}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        style={{ ["--fill" as string]: `${value}%` }}
        aria-valuetext={`${value} por ciento, ${describe(value)}`}
      />

      <div className="energy__scale" aria-hidden="true">
        {[0, 20, 40, 60, 80, 100].map((tick) => (
          <span key={tick}>{tick}</span>
        ))}
      </div>
    </div>
  );
}
